import 'twin.macro';
import React from 'react';
import { Surligner } from '@teetsh/app/src/containers/CahierJournal/Print/componentsSexy/Surligner';
import { Color } from '@teetsh/app/src/types/colors';

interface Props {
  children: React.ReactNode;
  isHighlighted?: boolean;
  color?: Color;
}

export function Label(props: Props) {
  const { children, isHighlighted, color } = props;
  if (isHighlighted) {
    return (
      <div tw="w-full">
        <Surligner tw="w-full" color={color} truncate={false}>
          {children}
        </Surligner>
      </div>
    );
  }
  return (
    <div style={{ fontSize: '90%' }} tw="text-muted">
      {children}
    </div>
  );
}
